  import { useEffect, useState, useCallback, useContext } from "react";
  import { Box, Button, Container, MenuItem, Typography, useMediaQuery, Chip, TextField, DialogActions} from "@mui/material";
  import { DataGrid, useGridApiRef} from "@mui/x-data-grid";
  import { PrintOutlined, CheckCircleOutline,SystemUpdateAltOutlined, Verified, InfoOutlined} from "@mui/icons-material";
  import GradientLoader from "../../components/CommanComponents/GradientLoader";
  import DialogBox from "../../components/ajax/DialogBox";
  import { useNavigate } from "react-router-dom";
  import { callPostApi } from "../../function/ApiCallFunction";
  import { toast } from "react-toastify";
  import LoadQRCode from './LoadQRCode';
import { DataContext } from "../../context/DataContext";

  // --- Helper: QR Status mapping
  const STATUS_MAP  = { Pending: "0", Loaded: "1", Activated: "2" };

  export default function LoadQR() 
  {
      const navigate = useNavigate();
      const {loginData,setLoginData } = useContext(DataContext);
      const store_id = loginData?.store_info?.store_id;
      
      const isMobile = useMediaQuery('(max-width:768px)');

      const apiRef = useGridApiRef();
      const [datar,     setDatar]     = useState([]);
      const [loading,   setLoading]   = useState(false);
      const [loadedNo,  setLoadedNo]  = useState('');
      const [amount,    setAmount]    = useState('');
      const [errors,    setErrors]    = useState({});
      const [open,      setOpen]      = useState(false);
    
      const [selectionModel,  setSelectionModel]  = useState(['']); 
      const [filterLimit,     setFilterLimit]     = useState(100);
      const [filterStatus,    setFilterStatus]    = useState('Pending');
      const [filterLotNo,     setFilterLotNo]     = useState('');
      const [filterLoadedNo,  setFilterLoadedNo]  = useState('');
      
      

      // --- Validate inputs
      const validate = () => 
      {
        const newErrors = {};
        if (!amount || isNaN(amount) || Number(amount) <= 0) newErrors.amount = "Enter a valid Amount";
        if (!loadedNo || isNaN(loadedNo) || Number(loadedNo) <= 0) newErrors.loadedNo = "Enter a valid Loading Number";
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };

      //API for QR list
      const QRListApi = useCallback(async (status, lotno, loadedno, limit) => 
      {
          try 
          {
            setLoading(true);
            const qrstatus = STATUS_MAP[status] || "";

            const payload = { mod: "CASHI_QECODE_LIST",  data_arr: { store_id, genLotNumber: lotno, loadingNumber:loadedno,qrcodeStatus:qrstatus, start: '0', limit:filterLimit,},};
            const apiResult = await callPostApi("cashi-qrcode", payload);

            if (apiResult.status === "200" && Array.isArray(apiResult.data)) 
            {
                const formattedData = apiResult.data.filter(item => item.redeem_status === "0").map((item, index) => 
                {
                    const dateMap = { '0': item.date_added, '1': item.loading_date, '2': item.active_date };
                    const statusLabelMap = { '0': 'Pending', '1': 'Loaded', '2': 'Activated' };
                    
                    return {
                        id      : item.id,
                        sr      : index + 1,
                        lotno   : item.gen_lot_number || "NA",
                        qr      : item.qrcode_number || "NA",
                        expdate : dateMap[item.qrcode_status] || "NA",
                        amount  : item.amount || "0",
                        loadedno: item.loading_number || "0",
                        statuss : item.qrcode_status_name || "NA",
                        status  : statusLabelMap[item.qrcode_status] || "NA",
                    };
                });

                setDatar(formattedData); 
            } 
            else { setDatar([]); }
          } catch (err) { } 
          finally { setLoading(false); }
          
      }, [store_id, filterLimit]);

      //Refresh store amount
      const refreshPage = useCallback(async (e) =>
      {
          try 
          {
            const payload = { mod: "STORE_DETAIL", data_arr: { store_id }, };
            const apiResult = await callPostApi("store-login", payload);

            if (apiResult.status === "200" && apiResult.data) 
            {
                setLoginData(prev => 
                {
                    const updated = {...prev, store_info: apiResult.data.store_info };
                    sessionStorage.setItem('loginData', JSON.stringify(updated));
                    return updated;
                });
               window.dispatchEvent(new Event('refreshNavbar'));
            } 
          } 
          catch (error) {} 
      },[store_id,setLoginData]);

      //API to load QR
      const loadqrapi = useCallback(async (selectedArray) => 
      {
          try 
          {
              setLoading(true);

              const payload = { mod: "LOAD_CASHI_QECODE", data_arr: { store_id, amount, loading_number:loadedNo,tagLotId:selectedArray} };
              const apiResult = await callPostApi("cashi-qrcode", payload);

              if (apiResult.status === "200") 
              {
                setOpen(false);
                setLoadedNo("");
                refreshPage();
                QRListApi('Pending', '', '', '100' );
              } 
              else { toast.info(apiResult.status_message); }
          } 
          catch (err) { } 
          finally { setLoading(false); }
        },[store_id,amount,loadedNo,QRListApi,refreshPage]);
      
      const applyFilter = () => QRListApi(filterStatus, filterLotNo, filterLoadedNo, filterLimit);
      
      const clearFilter = () => 
      {
        setFilterStatus('Pending');
        setFilterLotNo('');
        setFilterLoadedNo('');
        setFilterLimit(100);
        QRListApi('Pending', '', '', 100);
      };

      const handleActivateSuccess = useCallback(async () => 
      {
            setFilterStatus('Pending');
            setFilterLotNo('');
            setFilterLoadedNo('');
            setFilterLimit(100);
            await QRListApi('Pending', '', '', '100');
        }, [QRListApi]);

        // --- Open Load Dialog
        const openLoadDialog = () => {
          if (selectionModel.length === 0) return toast.info("Please select at least one QR!");
          setOpen(true);
        };

        // --- Handle Ok in Load Dialog
        const handleOk = () => 
        {
          if (!validate()) return;   loadqrapi(selectionModel);
        };

        // --- Effect: Fetch initial data and resize columns
        useEffect(() => {
          QRListApi(filterStatus, filterLotNo, filterLoadedNo, filterLimit);
        }, [filterStatus, filterLotNo, filterLoadedNo, filterLimit, QRListApi]);

        useEffect(() => {
          if (isMobile && apiRef.current) apiRef.current.autosizeColumns({ includeHeaders: true });
        }, [isMobile,apiRef]);

        const columns = [
          { field: 'sr', headerName: 'Sr no.', flex: isMobile ? undefined : 0.5},
          { field: 'qr', headerName: 'QR',  flex: isMobile ? undefined : 1,}, 
          { field: 'amount', headerName: 'Amount', flex: isMobile ? undefined : 1 },
          { field: 'status', headerName: 'Status', flex: isMobile ? undefined : 1,
            renderCell: (params) => 
            {
              let color = "#000", border = "1px solid #ccc", icon = null;
              switch (params.value) {
                  case "Activated":
                    color = "#098665"; 
                    border = `1px solid ${color}`; 
                    icon = <Verified sx={{ fontSize: 18 }} />;
                    break;
                  case "Pending":
                    color = "#e9aa0a"; 
                    border = `1px solid ${color}`; 
                    icon = <InfoOutlined sx={{ fontSize: 18 }} />;
                    break;
                  case "Loaded":
                    color = "#0a32d4"; 
                    border = `1px solid ${color}`; 
                    icon = <CheckCircleOutline sx={{ fontSize: 18 }} />;
                    break;
                  default:
                    color = "#000";
                    border = "1px solid #ccc";
                    icon = null;
                    break;
                }

              return (
                <Chip
                  icon={icon}
                  label={params.value}
                  variant="outlined"
                  sx={{ borderRadius: 18, fontWeight: 500, border, color }}
                  onClick={refreshPage} // ✅ safe, memoized
                />
              );
            }
          },
          { field: 'lotno', headerName: 'Lot Number', flex: isMobile ? undefined : 1 },
          { field: 'loadedno', headerName: 'Loading Number', flex: isMobile ? undefined : 1 },
          { field: 'expdate', headerName: 'Date', flex: isMobile ? undefined : 1 }, 
        ];


    return (
      <Container>
        
        <Box sx={{ display: 'flex', justifyContent: 'start', mb: 2 }}>
          <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}
            onClick={() => navigate(-1)} >  Back </Button>
        </Box>

        <Typography   variant="h6" gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)',
            p: 1,  color: '#ffffff', borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center'}}  >
          <SystemUpdateAltOutlined sx={{mx:1, fontSize:'22px'}}/>  
          QR Coupon List
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
          <Button variant="contained"  sx={{ background:'linear-gradient(195deg, #42424a, #191919)', 
            color: '#ffffff'}} onClick={() => navigate('/dashboardPlus/printQR')} >
            <PrintOutlined sx={{mx:1}}/> Print QR
          </Button>
        
        {/* Load Button */}
        {filterStatus === "Pending" ?   <Button variant="contained" sx={{ background:'linear-gradient(195deg, #49a3f1, #1A73E8)', color: '#ffffff',ml:1}}
            onClick={openLoadDialog} >
            <SystemUpdateAltOutlined sx={{mx:1, fontSize:'22px'}}/> Load
          </Button> : " "}

          {/* Active Button */}
          {filterStatus === "Loaded" ? <LoadQRCode idsss={selectionModel} apiRef={apiRef}  onSuccess={handleActivateSuccess} /> : ""}
            
        </Box>
      
          {/* Filter section work */}
          <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>
          <TextField select label="Filter Status" value={filterStatus} onChange={e => { setFilterStatus(e.target.value);}} sx={{ minWidth: 140 }} >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Loaded">Loaded</MenuItem>
              <MenuItem value="Activated">Activated</MenuItem>
          </TextField>
          <TextField type='text' label="Lot Number" value={filterLotNo} onChange={e => setFilterLotNo(e.target.value)} sx={{ minWidth: 140 }} >
          </TextField>
          <TextField type='text' label="Loading Number" value={filterLoadedNo} onChange={e => setFilterLoadedNo(e.target.value)}
            sx={{ minWidth: 140 }} />
          <TextField select label="Limit" value={filterLimit} onChange={e => { setFilterLimit(e.target.value);}} sx={{ minWidth: 140 }} >     
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={300}>300</MenuItem>
              <MenuItem value={500}>500</MenuItem>
              <MenuItem value={2000}>All</MenuItem>
          </TextField>
          
          <Button variant="outlined" color="primary" sx={{ height: 56 }} onClick={applyFilter}>Apply Filter</Button>
          <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={clearFilter}>Clear Filter</Button>
        
        </Box>

        {/* DataGrid */}
        <Box sx={{ height: 'auto', width: '100%', mb: 4 }}>
          <DataGrid  apiRef={apiRef} rows={datar} columns={columns}
            initialState={{ pagination: { paginationModel: { pageSize: 10 },}, }} pageSizeOptions={[10, 25, 50]}
            showToolbar checkboxSelection
            selectionModel={selectionModel}
            onRowSelectionModelChange={(newRowSelectionModel) => { setSelectionModel(newRowSelectionModel); }}
            sx={{
              '& .MuiDataGrid-cell': {
                whiteSpace: 'normal',     // Allow wrapping
                lineHeight:'20px',
                wordBreak: 'break-word', 
                display: 'flex',
                alignItems: 'center', // Vertically center content
                gap: '4px'},
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f0f0f0',
                color: '#000',
                fontWeight: 'bold',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontSize: 14,
                fontWeight: '600',
                whiteSpace: 'normal',
                wordBreak: 'break-word'
              },
            }}
          />
        </Box>

        <DialogBox open={open} onClose={() => setOpen(false)} title="Load QR Code">
            <TextField className="transparent-textfield" fullWidth margin="normal" label="Loading No." required  value={loadedNo}  
              onChange={(e) => { const value = e.target.value; setErrors(prev => ({ ...prev, loadedNo: undefined }));
                if (/^\d{0,6}$/.test(value)) { setLoadedNo(value); setErrors((prev) => ({ ...prev, loadedNo: undefined }));} }}
                error={!!errors.loadedNo} helperText={errors.loadedNo} type="number" inputprops={{ min: 1 }}/>

            <TextField className="transparent-textfield" fullWidth margin="normal" label="Enter Amount" required  value={amount}  
              onChange={(e) =>  { setAmount(e.target.value); setErrors(prev => ({ ...prev, amount: undefined }));}}
              error={!!errors.amount} helperText={errors.amount} type="number" inputprops={{ min: 1 }}/>
        <DialogActions>
            <Button onClick={() => setOpen(false)} color="primary"> Cancel </Button>
            <Button onClick={() => {handleOk()}} color="primary" variant="contained"> Ok </Button>
        </DialogActions>
        </DialogBox>

      {loading && <GradientLoader text="Loading" />} 
      </Container>
    );
  }
